import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ToastrService } from 'ngx-toastr';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { MachineBoardService } from 'src/app/services/machineBoard.service';
import { MachineBoard } from '../../../models/machineBoard';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _moment from 'moment';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CrewScheduleService } from 'src/app/services/crewSchedule.service';
import { Multilingual } from 'src/app/services/multilingual';
import { ProductivityService } from 'src/app/services/productivity-service';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import highcharts3D from 'highcharts/highcharts-3d';
import { element } from 'protractor';
highcharts3D(Highcharts);
const moment = _moment;
interface SelectInterFace {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-machineboard',
  templateUrl: './machineboard.component.html',
  styleUrls: ['./machineboard.component.scss'],
})
export class MachineboardComponent implements OnInit {
  loading = false;
  machineBoardData = false;
  showMode = false;
  isMachineBoardModelVisible = false;
  displayMachineModal = false;
  UnitName!: any;
  MachineId!: any;
  level!: any;
  MachineDashboardList!: any[];
  EmpltyArray!: any[];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  date1!: any;
  date2!: any;
  titles!: any[];
  ONE_HOUR = 60 * 60 * 1000;
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  currentUser!: MachineBoard;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  FromTimePicker!: Date;
  ToTimePicker!: Date;
  lang: any;
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList1!: any[];
  unitList!: any[];
  heirarchyData!: any[];
  options: any;
  chartAvailPlant!: Chart;
  chartPerformPlant!: Chart;
  chartQualPlant!: Chart;
  chartOeePlant!: Chart;
  chartStackedLine!: Chart;
  chartStackedUnit!: Chart;
  IsUnit: boolean = false;
  IsLosses: boolean = false;
  chartMonthlyOeeDrill!: Chart;
  OeeDashboardData!: any;
  selectedLine: any;
  static OeeDashboardDataglobal: any; //global for tooltip
  constructor(
    private formBuilder: FormBuilder,
    private enterpriseGroupService: EnterPriseGroupService,
    private toaster: ToastrService,
    private mbService: MachineBoardService,
    private usermanagementService: UserManagementService,
    public router: Router,
    private kpiMaster: KpimasterService,
    private spinner: NgxSpinnerService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private crewService: CrewScheduleService,
    private productivityservice: ProductivityService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
  }
  get unitDetailFormControls(): any {
    return this.searchForm.controls;
  }
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  activeButton!: any;
  key: any;
  crewScheduleList: any;
  // colorAvailability: ThemePalette = 'primary';
  // colorPerformance: ThemePalette = 'accent';
  // colorQuality: ThemePalette = 'warn';
  barOptionsList: any[] = [
    'PuDesc',
    'AvailableRate',
    'PerformanceRate',
    'QualityRate',
    'NetProduction',
    'PercentOEE',
    'OeeStatus',
    'MachineStatus',
  ];

  searchForm!: FormGroup;
  heirarchyDashboardForm!: FormGroup;
  // fot data
  groupList!: any[];
  lineList: SelectInterFace[] = [
    { value: 'die-cutting', viewValue: 'Die Cutting' },
    { value: 'pie-cutting', viewValue: 'Pie Cutting' },
    { value: 'lie-cutting', viewValue: 'Lie Cutting' },
  ];
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;
  ngOnInit(): void {
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.getGroupList();
    // this.GetMachineDashboard();
    // search form
    this.date1 = new Date();
    this.date2 = new Date(new Date().getTime() + this.ONE_HOUR);
    this.searchForm = this.formBuilder.group({
      group: ['', Validators.required],
      unit: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

    const dateStart = new Date();
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);
    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.heirarchyDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
    });


    const d = new Date();
    d.setDate(d.getDate() - 1);
    const start = new Date();
    this.FromTimePicker = d;
    this.ToTimePicker = new Date();
    this.searchForm.get('startDate')?.setValue(d);
    this.searchForm.get('endDate')?.setValue(this.ToTimePicker);
    this.datasource();
  }

  getGroupList(): void {
    const key = {
      Id: 0,
    };
    this.mbService.getGroupList(key).subscribe((res: any) => {
      this.groupList = res.masterList;
      this.searchForm.get('group')?.setValue(this.groupList[0].TypeId);
    });
  }
  groupChange(): void {
    this.searchForm.get('unit')?.reset();
  }


  today(): void {
    this.constructData_CS();
  }

  yesterday(): void {
    //this.constructData_LS();
    this.getShiftDates_LS();
  }


  yesterdayFullDay(): void {
    this.constructData_1D();
  }

  lastWeek(): void {
    this.constructData_1W();
  }

  lastMonth(): void {
    this.constructData_1M();
  }


  constructData_CS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.searchForm.get('startDate')?.patchValue(stDT);
    this.searchForm.get('endDate')?.patchValue(edDT);
    this.getShiftDates_CS();
  }

  constructData_LS(): void {
    const currentDT = new Date();

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);

    const stDT = new Date();
    stDT.setHours(19);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    if (currentDT.getTime() > stDT.getTime()) {
      this.searchForm.get('startDate')?.patchValue(edDT);
      this.searchForm.get('endDate')?.patchValue(stDT);
    }
    else {
      stDT.setDate(stDT.getDate() - 1);
      this.searchForm.get('startDate')?.patchValue(stDT);
      this.searchForm.get('endDate')?.patchValue(edDT);

    }

    this.getShiftDates_LS();
  }

  constructData_1D(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.searchForm.get('startDate')?.patchValue(stDT);
    this.searchForm.get('endDate')?.patchValue(edDT);

    this.getShiftDates_1D();
  }

  constructData_1W(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    const startDt = stDT;
    const endDt = edDT;
    this.searchForm.get('startDate')?.patchValue(stDT);
    this.searchForm.get('endDate')?.patchValue(edDT);

    this.getShiftDates_1W();
  }

  constructData_1M(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 29);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    const startDt = stDT;
    const endDt = edDT;
    this.searchForm.get('startDate')?.patchValue(stDT);
    this.searchForm.get('endDate')?.patchValue(edDT);

    this.getShiftDates_1M();
  }

  getShiftDates_CS(): void {

    const stDT = new Date();
    stDT.setDate(stDT.getDate());

    const key = {
      Id: this.MachineId,
      Date: stDT,
      EG_Id: this.searchForm.value.group,
      Level: this.level
    };

    this.crewService.GetShiftNowByPlantOrLine(key).subscribe((res: any) => {
      this.crewScheduleList = res.masterList;
      const date = new Date();
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList?.filter(
        (c: any) =>
          date.getTime() >= new Date(c.shiftStartTime).getTime() &&
          date.getTime() <= new Date(c.shiftEndTime).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        const endDT = new Date();
        endDT.setDate(endDT.getDate());
        this.searchForm.get('startDate')?.patchValue(record[0].shiftStartTime);
        this.searchForm.get('endDate')?.patchValue(endDT);
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();

      } else {
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();
      }
    });
  }

  getShiftDates_LS(): void {

    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate());
    lastshifttDT.setHours(lastshifttDT.getHours() - 12);
    lastshifttDT.setMinutes(0);
    lastshifttDT.setSeconds(0);

    const key = {
      Id: this.MachineId,
      Date: lastshifttDT,
      EG_Id: this.searchForm.value.group,
      Level: this.level
    };

    this.crewService.GetShiftNowByPlantOrLine(key).subscribe((res: any) => {
      this.crewScheduleList = res.masterList;
      const date = new Date();
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList.filter(
        (c: any) =>
          lastshifttDT.getTime() >= new Date(c.shiftStartTime).getTime() &&
          lastshifttDT.getTime() <= new Date(c.shiftEndTime).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.searchForm.get('startDate')?.patchValue(record[0].shiftStartTime);
        this.searchForm.get('endDate')?.patchValue(record[0].shiftEndTime);
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();

      } else {
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();
      }
    });
  }

  getShiftDates_1D(): void {

    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 1);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);

    const key = {
      Id: this.MachineId,
      Date: lastshifttDT,
      EG_Id: this.searchForm.value.group,
      Level: this.level
    };

    this.crewService.GetShiftNowByPlantOrLine(key).subscribe((res: any) => {
      this.crewScheduleList = res.masterList;
      const record = this.crewScheduleList;

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.searchForm.get('startDate')?.patchValue(record[0].shiftStartTime);
        this.searchForm.get('endDate')?.patchValue(edDT);
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();

      } else {
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();
      }
    });
  }

  getShiftDates_1W(): void {

    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 7);

    const key = {
      Id: this.MachineId,
      Date: lastshifttDT,
      EG_Id: this.searchForm.value.group,
      Level: this.level
    };

    this.crewService.GetShiftNowByPlantOrLine(key).subscribe((res: any) => {
      this.crewScheduleList = res.masterList;
      const endDT = new Date();
      endDT.setDate(endDT.getDate());
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList.filter(
        (c: any) =>
          lastshifttDT.getTime() >= new Date(c.shiftStartTime).getTime() &&
          lastshifttDT.getTime() <= new Date(c.shiftEndTime).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.searchForm.get('startDate')?.patchValue(record[0].shiftStartTime);
        this.searchForm.get('endDate')?.patchValue(endDT);
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();

      } else {
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();
      }
    });
  }

  getShiftDates_1M(): void {

    const lastshifttDT = new Date();
    lastshifttDT.setDate(lastshifttDT.getDate() - 30);

    const key = {
      Id: this.MachineId,
      Date: lastshifttDT,
      EG_Id: this.searchForm.value.group,
      Level: this.level
    };

    this.crewService.GetShiftNowByPlantOrLine(key).subscribe((res: any) => {
      this.crewScheduleList = res.masterList;
      const endDT = new Date();
      endDT.setDate(endDT.getDate());
      // tslint:disable-next-line:max-line-length
      const record = this.crewScheduleList.filter(
        (c: any) =>
          lastshifttDT.getTime() >= new Date(c.shiftStartTime).getTime() &&
          lastshifttDT.getTime() <= new Date(c.shiftEndTime).getTime()
      );

      if (record.length) {
        // Set the start date as shift start datetime and End date as current datetime
        this.searchForm.get('startDate')?.patchValue(record[0].shiftStartTime);
        this.searchForm.get('endDate')?.patchValue(endDT);
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();

      } else {
        this.key = {
          EGID: this.searchForm.value.group,
          PLID: this.MachineId,
          StartTime: this.searchForm.value.startDate,
          EndTime: this.searchForm.value.endDate,
          Level: this.level,
        };
        this.GetMachineDashboardForFilters();
      }
    });
  }


  GetMachineDashboard(): void {
    this.loading = true;
    let endDate = new Date(this.date2).toLocaleString();
    const date = endDate.toLocaleString().split(',')[0].trim().split('/');
    const time = endDate
      .toLocaleString()
      .split(',')[1]
      .trim()
      .split(' ')[0]
      .trim()
      .split(':');
    endDate =
      date[2] + '/' + date[0] + '/' + date[1] + ' ' + time[0] + ':' + time[1];
    const key = {
      EGID: this.searchForm.value.group,
      PLID: this.MachineId, // this.searchForm.value.unit,
      StartTime: this.searchForm.value.startDate, // '2021/03/29 11:41', // new Date(endDate),
      EndTime: this.searchForm.value.endDate, // '2021/03/29 11:46' // new Date(endDate),
      Level: this.level,
    };
    this.spinner.show();

    this.mbService.GetMachineDashboard(key).subscribe(
      (res: any) => {
        if (res.HasError === true) {
          this.spinner.hide();
          this.EmpltyArray = this.MachineDashboardList;
          this.toaster.error('Machine Not Found..!', res.message);
        } else {
          this.spinner.hide();
          this.loading = false;
          const array = res.OeeList;
          array.forEach((element: any) => {
            let colorCode = '';
            if (
              Math.round(element.PercentOEE) > 0 &&
              Math.round(element.PercentOEE) <= 20
            ) {
              colorCode = '#FF0000';
            } else if (
              Math.round(element.PercentOEE) > 20 &&
              Math.round(element.PercentOEE) <= 50
            ) {
              colorCode = '#ffff00';
            } else if (
              Math.round(element.PercentOEE) > 50 &&
              Math.round(element.PercentOEE) <= 70
            ) {
              colorCode = '#ffa500';
            } else if (Math.round(element.PercentOEE) > 70) {
              colorCode = '#008000';
            }
            element.colorAvailability = this.colorCode(
              element.AvailableRate.toFixed(2)
            );
            element.colorPerformance = this.colorCode(
              element.PerformanceRate.toFixed(2)
            );
            element.colorQuality = this.colorCode(
              element.QualityRate.toFixed(2)
            );
            element.AvailableRate = element.AvailableRate.toFixed(2);
            element.PerformanceRate = element.PerformanceRate.toFixed(2);
            element.QualityRate = element.QualityRate.toFixed(2);
            element.NetProduction = element.NetProduction.toFixed(2);
            element.barOptionsBobst = {
              barType: 'radial',
              color: colorCode,
              secondColor: '#E5E5E5',
              progress:
                Math.round(element.PercentOEE) > 0
                  ? Math.round(element.PercentOEE)
                  : ' 0 ',
              radial: {
                depth: 9,
                size: 96,
                label: {
                  enable: true,
                  color: '#09608c',
                },
              },
            };
          });
          this.MachineDashboardList = array;
          this.showMode = true;
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  GetMachineDashboardForFilters(): void {
    this.spinner.show();
    this.mbService.GetMachineDashboard(this.key).subscribe(
      (res: any) => {
        if (res.HasError === true) {
          this.spinner.hide();
          this.EmpltyArray = this.MachineDashboardList;
          this.toaster.error('Machine Not Found..!', res.message);
        } else {
          this.spinner.hide();
          this.loading = false;
          const array = res.OeeList;
          array.forEach((element: any) => {
            let colorCode = '';
            if (
              Math.round(element.PercentOEE) > 0 &&
              Math.round(element.PercentOEE) <= 20
            ) {
              colorCode = '#FF0000';
            } else if (
              Math.round(element.PercentOEE) > 20 &&
              Math.round(element.PercentOEE) <= 50
            ) {
              colorCode = '#ffff00';
            } else if (
              Math.round(element.PercentOEE) > 50 &&
              Math.round(element.PercentOEE) <= 70
            ) {
              colorCode = '#ffa500';
            } else if (Math.round(element.PercentOEE) > 70) {
              colorCode = '#008000';
            }
            element.colorAvailability = this.colorCode(
              element.AvailableRate.toFixed(2)
            );
            element.colorPerformance = this.colorCode(
              element.PerformanceRate.toFixed(2)
            );
            element.colorQuality = this.colorCode(
              element.QualityRate.toFixed(2)
            );
            element.AvailableRate = element.AvailableRate.toFixed(2);
            element.PerformanceRate = element.PerformanceRate.toFixed(2);
            element.QualityRate = element.QualityRate.toFixed(2);
            element.NetProduction = element.NetProduction.toFixed(2);
            element.barOptionsBobst = {
              barType: 'radial',
              color: colorCode,
              secondColor: '#E5E5E5',
              progress:
                Math.round(element.PercentOEE) > 0
                  ? Math.round(element.PercentOEE)
                  : ' 0 ',
              radial: {
                depth: 9,
                size: 96,
                label: {
                  enable: true,
                  color: '#09608c',
                },
              },
            };
          });
          this.MachineDashboardList = array;
          this.showMode = true;
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  colorCode(value: any): any {
    let colorCode = '';
    if (Math.round(value) > 0 && Math.round(value) <= 20) {
      return (colorCode = 'warn');
    } else if (Math.round(value) > 20 && Math.round(value) <= 50) {
      return (colorCode = 'primary');
    } else if (Math.round(value) > 50 && Math.round(value) <= 70) {
      return (colorCode = 'secondary');
    } else if (Math.round(value) > 70) {
      return (colorCode = 'accent');
    } else if (Math.round(value) === 0) {
      return (colorCode = '');
    }
  }
  openTreeModal(): void {
    this.machineBoardData = true;
    const key = {
      EGId: this.searchForm.value.group,
      level: 'Line',
      CreatedBy: 0,
      IsOptional: 0,
    };

    this.enterpriseGroupService.getTreeModal(key).subscribe(
      (data: any) => {
        // tslint:disable-next-line:no-shadowed-variable
        const plantGroupData: PlantGroupElement[] = data.TreeModalList;
        this.plantGroupSource.data = plantGroupData;
        this.treeControl.dataNodes = this.plantGroupSource.data;
        this.isMachineBoardModelVisible = true;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  onNodeSelect(node: any): void {
    //
    this.machineBoardData = false;
    // tslint:disable-next-line: align
    this.level = node.Level
    this.MachineId = node.PrimaryId;
    this.searchForm.get('unit')?.setValue(node.text);
    this.constructData_CS();
  }

  SelectUnitName(unitname: any): void {
    if (unitname.Level === 'Unit') {
      this.UnitName = unitname.text;
      this.isMachineBoardModelVisible = false;
    }
  }

  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  closeaddNewPlantItemModel(): void {
    this.displayMachineModal = false;
  }

  closePlantGroupModel(): void {
    this.machineBoardData = false;
  }

  expandAllNode(): void {
    this.treeControl.expandAll();
  }

  collapseAllNode(): void {
    this.treeControl.collapseAll();
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  //date formatter
  dateAsYYYYMMDDHHNNSS(date: any): string {
    return (
      date.getFullYear() +
      '-' +
      this.leftpad(date.getMonth() + 1, 2) +
      '-' +
      this.leftpad(date.getDate(), 2) +
      ' ' +
      this.leftpad(date.getHours(), 2) +
      ':' +
      this.leftpad(date.getMinutes(), 2)
    );
  }
  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  showPhase(event: any) {
    this.activeButton = event;
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }

  // Plant Heirarchy tab code -------//

  datasource(): void {
    const key = {
      UserId: 206     //later it will be change this is only for testing
    };
    const id = {
      value: 0
    };
    this.productivityservice.getGroupData(key).subscribe((data: any) => {
      this.GroupList = data.lstEG;
      if (this.GroupList.length > 0) {
        id.value = data.lstEG[0].EG_Id;
        this.heirarchyDashboardForm.get('UserGroup1')?.setValue(data.lstEG[0].EG_Id);
        this.heirarchyDashboardForm.get('UserPlant1')?.setValue(data.lstEG[0].EG_Id);
        this.filteredGroups = this.GroupList.slice();
        this.getPlants(id);
      }
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: event.value,
      userId: 206
    };
    this.productivityservice.getPlantsData(key).subscribe((data: any) => {
      this.PlantList1 = data.lstPlant;
      if (this.PlantList1.length > 0) {
        const id = data.lstPlant[0].PT_Id;
        this.heirarchyDashboardForm.get('UserPlant1')?.patchValue(id);
        this.filteredPlants = this.PlantList1.slice();
        this.getLine(id);
      }
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }
  getLine(id: any) {
    const key = {
      PT_ID: id,
      userId: 206
    };

    this.productivityservice.getLineData(key).subscribe((data: any) => {
      this.lineList1 = data.lstLine;
      if (this.lineList1.length > 0) {
        this.filteredLines = this.lineList1.slice();
      }
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  onSubmit(): void {
    this.spinner.show();
    const key = {
      PlantId: this.heirarchyDashboardForm.get('UserPlant1')?.value,
      lineId: this.heirarchyDashboardForm.get('line')?.value === '' ? 0 : this.heirarchyDashboardForm.get('line')?.value,
      level: this.heirarchyDashboardForm.get('line')?.value === '' ? 'plant' : 'line',
      startDate: this.heirarchyDashboardForm.get('dateStart')?.value,
      endDate: this.heirarchyDashboardForm.get('dateEnd')?.value
    }
    this.mbService.GetPlantHeirarchyDashboard(key).subscribe((data: any) => {
      this.heirarchyData = data;
      this.drawAvailStacked(this.heirarchyData);
      this.drawAPerformanceStacked(this.heirarchyData);
      this.drawQualityStacked(this.heirarchyData);
      this.drawOEEStacked(this.heirarchyData);
      this.drawLineStacked(this.heirarchyData);
      this.spinner.hide();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
      this.spinner.hide();
    });
  }
  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangePlant(data: any): void {
    this.heirarchyDashboardForm.get('line')?.setValue('');
    this.IsUnit = false;
    this.getLine(data.value);
  }

  drawAvailStacked(data: any) {
    //availabilty
    let dataSetAvail = 0;
    data.Table1.forEach(element => {
      dataSetAvail = parseInt(element.AvailabilityRate.toFixed(0));
    })
    this.options = {
      chart: {
        type: "solidgauge",
        events: {
          render: function () {
            var point = this.series[0].points[0];
            if (point.y > 0 && point.y < 20) {
              point.graphic.attr({
                fill: '#fa1f0f'
              })
            } else if (point.y > 20 && point.y <= 50) {
              point.graphic.attr({
                fill: '#fae311'
              })
            }
            else if (point.y > 50 && point.y <= 70) {
              point.graphic.attr({
                fill: '#fc7005'
              })
            } else {
              point.graphic.attr({
                fill: '#069420'
              })
            }
          }
        }
      },
      title: {
        text: '<span style="font-size: 16px;  font-weight: bold;">Availability</span>',
        valueDecimals: 2,
        valueSuffix: ' %'
      },
      pane: {
        center: ['50%', '85%'],
        size: '140%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      credits: {
        enabled: false
      },
      yAxis: {
        stops: [
          [0.5, {
            linearGradient: {
              x1: 0,
              x2: 0,
              y1: 0,
              y2: 1
            },
            stops: [
              [0.1, '#55BF3B'], // green
              [0.5, '#55BF3B'], // yellow
              [0.9, '#55BF3B'] // red
            ],
          }]
        ],
        minorTickInterval: null,
        tickWidth: 0,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        lineWidth: 0,
        labels: {
          enabled: true
        },
        min: 0,
        max: 100

      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y} %'
          }
        },
      },
      series: [{ data: [dataSetAvail], name: 'Availability' }]
    };
    let chart = new Chart(this.options);
    this.chartAvailPlant = chart;
  }
  drawAPerformanceStacked(data: any) {
    //perform
    let dataSetPerform = 0
    data.Table1.forEach(element => {
      dataSetPerform = parseInt(element.PerformancRate.toFixed(0));
    })
    this.options = {
      chart: {
        type: "solidgauge",
        events: {
          render: function () {
            var point = this.series[0].points[0];
            if (point.y > 0 && point.y < 20) {
              point.graphic.attr({
                fill: '#fa1f0f'
              })
            } else if (point.y > 20 && point.y <= 50) {
              point.graphic.attr({
                fill: '#fae311'
              })
            }
            else if (point.y > 50 && point.y <= 70) {
              point.graphic.attr({
                fill: '#fc7005'
              })
            } else {
              point.graphic.attr({
                fill: '#069420'
              })
            }
          }
        }
      },
      title: {
        text: '<span style="font-size: 16px;  font-weight: bold;">Performance</span>',
        valueDecimals: 2,
        valueSuffix: ' %'
      },
      pane: {
        center: ['50%', '85%'],
        size: '140%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      credits: {
        enabled: false
      },
      yAxis: {
        stops: [
          [0.5, {
            linearGradient: {
              x1: 0,
              x2: 0,
              y1: 0,
              y2: 1
            },
            stops: [
              [0.1, '#55BF3B'], // green
              [0.5, '#55BF3B'], // yellow
              [0.9, '#55BF3B'] // red
            ],
          }]
        ],
        minorTickInterval: null,
        tickWidth: 0,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        lineWidth: 0,
        labels: {
          enabled: true
        },
        min: 0,
        max: 100

      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y} %'
          }
        },
      },
      series: [{ data: [dataSetPerform], name: 'Performance' }]
    };
    let chart = new Chart(this.options);
    this.chartPerformPlant = chart;
  }
  drawQualityStacked(data: any) {
    //quality
    let dataSetQuality = 0
    data.Table1.forEach(element => {
      dataSetQuality = parseInt(element.QualityRate.toFixed(0));
    })
    this.options = {
      chart: {
        type: "solidgauge",
        events: {
          render: function () {
            var point = this.series[0].points[0];
            if (point.y > 0 && point.y < 20) {
              point.graphic.attr({
                fill: '#fa1f0f'
              })
            } else if (point.y > 20 && point.y <= 50) {
              point.graphic.attr({
                fill: '#fae311'
              })
            }
            else if (point.y > 50 && point.y <= 70) {
              point.graphic.attr({
                fill: '#fc7005'
              })
            } else {
              point.graphic.attr({
                fill: '#069420'
              })
            }
          }
        }
      },
      title: {
        text: '<span style="font-size: 16px;  font-weight: bold;">Quality</span>',
        valueDecimals: 2,
        valueSuffix: ' %'
      },
      pane: {
        center: ['50%', '85%'],
        size: '140%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      credits: {
        enabled: false
      },
      yAxis: {
        stops: [
          [0.5, {
            linearGradient: {
              x1: 0,
              x2: 0,
              y1: 0,
              y2: 1
            },
            stops: [
              [0.1, '#55BF3B'], // green
              [0.5, '#55BF3B'], // yellow
              [0.9, '#55BF3B'] // red
            ],
          }]
        ],
        minorTickInterval: null,
        tickWidth: 0,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        lineWidth: 0,
        labels: {
          enabled: true
        },
        min: 0,
        max: 100

      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y} %'
          }
        },
      },
      series: [{ data: [dataSetQuality], name: 'Quality' }]
    };
    let chart = new Chart(this.options);
    this.chartQualPlant = chart;
  }
  drawOEEStacked(data: any) {
    //oee
    let dataSetoee = 0
    data.Table1.forEach(element => {
      dataSetoee = parseInt(element.OEE.toFixed(0));
    })
    this.options = {
      chart: {
        type: "solidgauge",
        events: {
          render: function () {
            var point = this.series[0].points[0];
            if (point.y > 0 && point.y < 20) {
              point.graphic.attr({
                fill: '#fa1f0f'
              })
            } else if (point.y > 20 && point.y <= 50) {
              point.graphic.attr({
                fill: '#fae311'
              })
            }
            else if (point.y > 50 && point.y <= 70) {
              point.graphic.attr({
                fill: '#fc7005'
              })
            } else {
              point.graphic.attr({
                fill: '#069420'
              })
            }
          }
        }
      },
      title: {
        text: '<span style="font-size: 16px;  font-weight: bold;">OEE</span>',
        valueDecimals: 2,
        valueSuffix: ' %'
      },
      pane: {
        center: ['50%', '85%'],
        size: '140%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      credits: {
        enabled: false
      },
      yAxis: {
        stops: [
          [0.5, {
            linearGradient: {
              x1: 0,
              x2: 0,
              y1: 0,
              y2: 1
            },
            stops: [
              [0.1, '#55BF3B'], // green
              [0.5, '#55BF3B'], // yellow
              [0.9, '#55BF3B'] // red
            ],
          }]
        ],
        minorTickInterval: null,
        tickWidth: 0,
        gridLineWidth: 0,
        gridLineColor: 'transparent',
        lineWidth: 0,
        labels: {
          enabled: true
        },
        min: 0,
        max: 100

      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{y} %'
          }
        },
      },
      series: [{ data: [dataSetoee], name: 'OEE' }]
    };
    let chart = new Chart(this.options);
    this.chartOeePlant = chart;
  }

  drawLineStacked(data: any) {
    let categories: any[] = new Array();
    let avalibility: any[] = new Array();
    let performance: any[] = new Array();
    let quality: any[] = new Array();
    let oee: any[] = new Array();
    data.Table.forEach(element => {
      categories.push(element.PL_Desc);
      avalibility.push(element.AvailabilityRate).toFixed(2);
      performance.push(element.PerformancRate).toFixed(2);
      quality.push(element.QualityRate).toFixed(2);
      oee.push(element.OEE).toFixed(2);
    })
    let colors = ['#464bf0', '#fca223', '#b2cf53', '#70e6d8'];
    this.options = {
      chart: {
        type: 'column'
      },
      colors: colors,
      title: {
        text: ''
      },
      xAxis: {
        categories: categories
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Line A.P.Q.OEE'
        },
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        //pointFormat: '{series.name}: {point.y:.2f}<br/>Total: {point.stackTotal}'
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            formatter: function () {
              return '</b>' + this.y.toFixed(2) + ' %';
            }
          }
        },
        series: {
          cursor: 'pointer',
          stacking: "normal",
          events: {
            click: this.drawUnitStacked.bind(this, this.heirarchyData)
          }
        },
      },
      series: [{
        name: 'OEE',
        data: oee
      }, {
        name: 'A',
        data: avalibility
      }, {
        name: 'P',
        data: performance
      }, {
        name: 'Q',
        data: quality
      },]
    };
    let chart = new Chart(this.options);
    this.chartStackedLine = chart;
  }
  drawUnitStacked(data: any, ClikedLine: any) {
    this.IsLosses = false;
    let categories: any[] = new Array();
    let avalibility: any[] = new Array();
    let performance: any[] = new Array();
    let quality: any[] = new Array();
    let oee: any[] = new Array();
    this.selectedLine = this.lineList1.find(l => l.PL_Desc === ClikedLine.point.category)
    data.Table2?.forEach(element => {
      if (element.PL_Id === this.selectedLine.PL_Id) {
        categories.push(element.PU_Desc);
        avalibility.push(element.AvailabilityRate).toFixed(2);
        performance.push(element.PerformancRate).toFixed(2);
        quality.push(element.QualityRate).toFixed(2);
        oee.push(element.OEE).toFixed(2);
      }
    })
    this.IsUnit = true;
    let colors = ['#464bf0', '#fca223', '#b2cf53', '#70e6d8'];
    this.options = {
      chart: {
        type: 'column'
      },
      colors: colors,
      title: {
        text: ''
      },
      xAxis: {
        categories: categories
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Unit A.P.Q.OEE'
        },
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        // pointFormat: '{series.name}: {point.y:.2f}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            formatter: function () {
              return '</b> ' + this.y.toFixed(2) + ' %';
            }
          }
        },
        series: {
          cursor: 'pointer',
          stacking: "normal",
          events: {
            click: this.getOeeDashboard.bind(this, this.heirarchyData)
          }
        },
      },
      credits: {
        enabled: false
      },
      series: [{
        name: 'OEE',
        data: oee
      }, {
        name: 'A',
        data: avalibility
      }, {
        name: 'P',
        data: performance
      }, {
        name: 'Q',
        data: quality
      }]
    };
    let chart = new Chart(this.options);
    this.chartStackedUnit = chart;
  }
  //============================================================  Drill Down ===========================================================//
  getOeeDashboard(data: any, ClickedUnit: any) {
    this.IsLosses = true;
    let selectedUnit = data.Table2.find(l => l.PU_Desc === ClickedUnit.point.category)
    const key = {
      dtStartDate: this.heirarchyDashboardForm.get('dateStart')?.value,
      dtEndDate: this.heirarchyDashboardForm.get('dateEnd')?.value,
      GroupId: this.heirarchyDashboardForm.get('UserGroup1')?.value,
      PlantId: this.heirarchyDashboardForm.get('UserPlant1')?.value,
      UnitId: selectedUnit.PUId,
      LineId: this.selectedLine.PL_Id,
      shift: '*',
    };
    this.spinner.show();
    this.productivityservice.getOEE(key).subscribe(
      (data: any) => {
        this.OeeDashboardData = data;
        this.monthlyOEEDrillDown();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }
  monthlyOEEDrillDown() {

    const parent = [];
    let child = [];
    const drillData = [];

    this.OeeDashboardData.dtDrillDownChartData.forEach(value => {
      this.OeeDashboardData.dtDrillDownChartData.forEach(val => {
        if (value.ParentId === 0 && value.id === val.ParentId) {
          const data = {
            name: value.Name,
            y: value.Perc,
            drilldown: val.id,
            Minutes: value.Value,
            Occurence: value.Occurrances
          }
          parent.push(data);
        }

      })
    })

    this.OeeDashboardData.dtDrillDownChartData.forEach((element) => {
      this.OeeDashboardData.dtDrillDownChartData.forEach(val => {
        if (element.id === val.ParentId && val.treeId === 0) {
          const dataChild = {
            name: element.Name,
            y: element.Perc,
            drilldown: val.id,
            Minutes: element.Value,
            Occurence: element.Occurrances
          }
          child.push(dataChild);
        }
      })
      const keyData = {
        id: element.id,
        name: element.Name,
        type: 'column',
        data: child.length > 0 ? child : [{ name: element.Name, y: element.Perc, drilldown: '', Minutes: element.Value, Occurence: element.Occurrances }]
      }
      drillData.push(keyData);
      child = [];

    })

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        labels: {
          format: '{value}%',
        },
        title: {
          text: 'OEE Looses',
        },
      },
      plotOptions: {
        // column: {
        //   dataLabels: {
        //     enabled: true,
        //     crop: true,
        //     inside: false,
        //     formatter: function () {
        //       return getDataLabels(this.y, this.series.data.length)
        //     },
        //   },
        // },
        series: {
          turboThreshold: 1000000,
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        valueDecimals: 2,
        formatter: function () {
          return '<b>' + this.point.options.name + ' :' + this.point.options.y + '</b></br><b>' + 'Duration (mins)' + ' :' + this.point.options.Minutes + '</b></br><b>' + 'Occurence' + ' :' + this.point.Occurence + '</b>'
        }
      },
      series: [
        {
          name: 'Main',
          type: 'column',
          colorByPoint: true,
          data: parent,
        },
      ],
      drilldown: {
        allowPointDrilldown: false,
        activeAxisLabelStyle: {
          textDecoration: 'none',
          fontStyle: 'normal',
        },
        activeDataLabelStyle: {
          textDecoration: 'none',
          fontStyle: 'normal',
        },
        series: drillData,
        drillUpButton: {
          relativeTo: 'spacingBox',
          position: {
            y: 0,
            x: 0,
          },
          theme: {
            fill: 'white',
            'stroke-width': 1,
            stroke: 'blue',
            r: 0,
            states: {
              hover: {
                fill: '#ffffff',
              },
              select: {
                stroke: '#039',
                fill: '#0f02fa',
              },
            },
          },
        },
      },
    };
    let chart = new Chart(this.options);
    this.chartMonthlyOeeDrill = chart;
  }
}


